import {Controller} from '@hotwired/stimulus';

/**
 * Masque des blocs tant que la dernière case modifiée d'un groupe est cochée : un même réglage saisi
 * une fois par langue d'un formulaire à versions, qui commande un bloc commun à toutes les langues.
 *
 *   <form {{ stimulus_controller('latest-checkbox-visibility') }}>
 *     <div {{ stimulus_target('latest-checkbox-visibility', 'group')
 *           |stimulus_action('latest-checkbox-visibility', 'update', 'change') }}>
 *       {{ form_row_v(form.versions, 'defaultDisposition') }}
 *     </div>
 *     <div {{ stimulus_target('latest-checkbox-visibility', 'dependent') }} hidden>…</div>
 *   </form>
 *
 * À la connexion, la dernière case du groupe décide ; ensuite, la case qui vient de changer. Le Twig
 * rend l'état initial (`hidden`). Un bloc masqué n'est ni vidé ni désactivé : ses champs restent
 * postés.
 */
export default class extends Controller {
  static targets = ['group', 'dependent'];

  connect() {
    const checkboxes = this.groupTarget.querySelectorAll('input[type="checkbox"]');

    if (checkboxes.length > 0) {
      this.#apply(checkboxes[checkboxes.length - 1].checked);
    }
  }

  update({target}) {
    if (target instanceof HTMLInputElement && target.type === 'checkbox') {
      this.#apply(target.checked);
    }
  }

  #apply(checked) {
    this.dependentTargets.forEach((dependent) => {
      dependent.hidden = checked;
    });
  }
}
